module.exports = __webpack_public_path__ + "static/media/stop_wars.af41b97a.jpg";